import { render, staticRenderFns } from "./modalEditarPrecio.vue?vue&type=template&id=f2921d56&"
import script from "./modalEditarPrecio.vue?vue&type=script&lang=js&"
export * from "./modalEditarPrecio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports